import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="This page lets you edit the details of a <strong>license</strong>, including its name, type, duration, and access options." id="this_page_lets_you_edit_the_details_of_a.af653ee3" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Editing a License" id="editing_a_license.524e1c0a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the deliverable sections to manage the <strong>practice tests</strong>, <strong>courses</strong>, and <strong>eBooks</strong> included in this license. Adjust seats and usage limits for each deliverable as needed." id="use_the_deliverable_sections_to_manage_t.1cc57a25" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Managing Deliverables" id="managing_deliverables.b48bcfa3" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="When you are finished, select <strong>Save</strong> to apply your changes." id="when_you_are_finished_select_save_to_app.89f7bad9" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Saving Changes" id="saving_changes.8e3f3c76" />
        }
    ],
    title: <FormattedMessage defaultMessage="License Help" id="license_help.66e0d8b6" />
};
